import { render, staticRenderFns } from "./CampaignPie.vue?vue&type=template&id=5dc24182&"
import script from "./CampaignPie.vue?vue&type=script&lang=js&"
export * from "./CampaignPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports